import { render, staticRenderFns } from "./ReportImageDriversLicense.vue?vue&type=template&id=35b868cd&scoped=true"
import script from "./ReportImageDriversLicense.vue?vue&type=script&lang=ts"
export * from "./ReportImageDriversLicense.vue?vue&type=script&lang=ts"
import style0 from "./ReportImageDriversLicense.vue?vue&type=style&index=0&id=35b868cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b868cd",
  null
  
)

export default component.exports